import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const Timer = ({isTimer, changeField}) => {
  return (
    <div className="additionalOptionItem">
      <div style={{width:'5%', marginLeft: 15, display: 'flex', alignItems: 'center'}}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isTimer}
              onChange={(e) => changeField(e.target.checked)}
              value=""
            />
          }
        />
      </div>
      <div style={{width:'95%'}}>
        <p>
          <b>Timer:</b>
          <span className="italics"> Enable 5 second workout preview prior to start of exercise.</span>
        </p>
      </div>
    </div>

  )
}

export default Timer;



// WEBPACK FOOTER //
// ./src/components/workouts/inputs/Timer.js